import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent, iif } from 'rxjs';
import { delay, filter, map, mergeMap } from 'rxjs/operators';
import { HubService } from 'src/app/admin/content/_shared/services/hub.service';
import { AccountService } from 'src/app/core/services/account.service';
import { DialogService } from '../../../../core/services/dialog.service';

@UntilDestroy()
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements AfterViewInit, OnChanges {
  @ViewChild('dialog', { static: true })
  dialog: TemplateRef<any>;
  rightsVisible: boolean = true;
  accountId: number;
  hubId: number;
  addingSupport = false;
  dialogRef: MatDialogRef<any, any>;
  @Input()
  opened: boolean = false;
  @Output()
  openedChange = new EventEmitter<boolean>();
  @ViewChild('tab', {static: true})
  tab: ElementRef<HTMLElement>;

  constructor(private d: DialogService, private router: Router, private route: ActivatedRoute, private hubService: HubService, private accountService: AccountService, private snackbar: MatSnackBar) {
    this.router.events.pipe(
      untilDestroyed(this),
      filter(x => x instanceof NavigationEnd),
      map(() => this.route),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.params)
    ).subscribe(param => {
      this.rightsVisible = !!param.accountId || !!param.hubId;
      this.accountId = param.accountId;
      this.hubId = param.hubId;
    });    
  }

  ngAfterViewInit(): void {
    this.repositionTab();
    fromEvent(window, 'scroll', { passive: true }).pipe(untilDestroyed(this)).subscribe(() => this.repositionTab());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.opened && changes.opened.currentValue) {
      this.openSupport();
    }
    else if (!!this.dialogRef) {
      this.dialogRef.close();
    }
  }

  repositionTab() {
    this.tab.nativeElement.style.top = (window.scrollY + 250) + "px";
  }

  openSupport() {    
    this.d.open(this.dialog, true).then(d => {
      this.dialogRef = d;
      d.afterClosed().subscribe(() => this.openedChange.emit(false));
    });
  }  

  addSupport() {
    this.addingSupport = true;
    iif(() => !!this.accountId,
    this.accountService.addSupportUser(this.accountId),
    this.hubService.addSupportUser(this.hubId)).subscribe(() => {
      this.addingSupport = false;
      this.dialogRef.close();
      this.snackbar.open($localize`Support har nu rättigheter`, null, { duration: 3000 });
    });
  }
}
